// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { type CategoryData } from 'store/modules/common';
import NewIcon from 'components/common/Icons/NewIcon/NewIcon';
import CategoryMenuBox from 'components/categories/CategoryMenuBox/CategoryMenuBox';
import './MainMobileHeadItem.scss';

type Props = {
  name: string,
  to: string,
  active: boolean,
  icon: Node,
  isMouseOver?: boolean,
  handleMouseOver?: Function,
  handleMouseLeave?: Function,
  isNew?: boolean,
  categories?: ?(CategoryData[]),
  history?: Object,
  itemRef?: Function,
};

const MainMobileHeadItem = ({
  to,
  name,
  active,
  isNew,
  isMouseOver,
  handleMouseLeave,
  handleMouseOver,
  categories,
  history,
  itemRef,
}: Props) => {
  if (name === '상품') {
    return (
      <li
        ref={itemRef}
        onMouseOver={handleMouseOver}
        onFocus={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        className={cx('MainMobileHeadItem', { active })}
      >
        <Link to={to} className="item-link">
          <div className="item-name">
            {name}
            {isNew && <NewIcon />}
          </div>
        </Link>
        {/* <TransitionGroup component={null}>
          {isMouseOver && (
            <CSSTransition classNames="show" timeout={250}>
              <CategoryMenuBox
                categories={categories}
                history={history}
                closeMenuBox={handleMouseLeave}
              />
            </CSSTransition>
          )}
        </TransitionGroup> */}
      </li>
    );
  }
  // else if (name === '랩스바이') {
  //   return (
  //     <li className={cx('MainMobileHeadItem', { active })}>
  //       <a href={to} target="_blank" className="item-link">
  //         <div className="item-name">
  //           {name}
  //           {isNew && <NewIcon />}
  //         </div>
  //       </a>
  //     </li>
  //   );
  // }
  return (
    <li ref={itemRef} className={cx('MainMobileHeadItem', { active })}>
      <Link to={to} className="item-link">
        <div className="item-name">
          {name}
          {isNew && <NewIcon />}
        </div>
      </Link>
    </li>
  );
};

export default MainMobileHeadItem;



// WEBPACK FOOTER //
// ./src/components/main/MainMobileHeadItem/MainMobileHeadItem.js